export const AUTHENTICATION = {
    SET_SIGN_IN_AZURE_CALLED: 'SET_SIGN_IN_AZURE_CALLED',
    SET_SIGN_IN_AZURE_SUCCESSFUL: 'SET_SIGN_IN_AZURE_SUCCESSFUL',
    SET_SIGN_IN_AZURE_ERROR: 'SET_SIGN_IN_AZURE_ERROR',

    SET_CODE_VERIFIE: 'SET_CODE_VERIFIE',
    SET_CODE: 'SET_CODE',
    SET_TOKEN: 'SET_TOKEN',
    SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
    SET_USER_MAIL: 'SET_USER_MAIL',
    SET_USER_FULL_NAME: 'SET_USER_FULL_NAME',
    SET_USER_DETAILS: 'SET_USER_DETAILS',
    SET_USER_CLIENTS: 'SET_USER_CLIENTS',
    SET_USER_ID_CLIENT: 'SET_USER_ID_CLIENT',
    SET_USER_ROLE: 'SET_USER_ROLE',
    SET_ACQUIRING_TOKEN: 'SET_ACQUIRING_TOKEN',

    SET_PORTAIL: 'SET_PORTAIL'
};

